<script setup>
</script>

<template>
  <main class="main">
    <h1>联系我们</h1>
    <div class="desc">我们会重视每一个用户提的建议，将认真研究并在7个工作日内回复！</div>
    
    <div class="contact">
      <div class="item">
        <div class="icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="#2B7BF3" stroke-width="2"/>
          </svg>
        </div>
        <span>邮箱</span>
        <span class="email">linkoffer@yeah.net</span>
      </div>

      <!-- <div class="item">
        <div class="icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="6" fill="#2B7BF3"/>
            <path d="M12 6.5c-3.3 0-6 2.2-6 4.9 0 1.5.8 2.8 2.1 3.7.2.1.3.3.3.5l-.1.7c0 .2.2.3.3.3l1.1-.6c.2-.1.3-.1.5 0 .6.2 1.2.3 1.8.3 3.3 0 6-2.2 6-4.9s-2.7-4.9-6-4.9zm-2.7 5.5c-.4 0-.8-.4-.8-.8s.4-.8.8-.8.8.4.8.8-.4.8-.8.8zm2.7 0c-.4 0-.8-.4-.8-.8s.4-.8.8-.8.8.4.8.8-.4.8-.8.8zm2.7 0c-.4 0-.8-.4-.8-.8s.4-.8.8-.8.8.4.8.8-.4.8-.8.8z" fill="white"/>
          </svg>
        </div>
        <span>企业微信</span>
        <div class="hint">添加获取更多信息</div>
        <img src="./qr-code.png" alt="企业微信二维码">
      </div> -->
    </div>
  </main>
</template>

<style scoped>
.main {
  min-height: calc(100vh - 60px);
  padding: 40px 0;
  text-align: center;
}

h1 {
  font-size: 36px;
  margin-bottom: 16px;
  font-weight: bold;
}

.desc {
  font-size: 15px;
  color: #6b7280;
  max-width: 600px;
  margin: 0 auto 60px;
  line-height: 1.5;
}

.contact {
  display: flex;
  justify-content: center;
  gap: 120px;
  max-width: 800px;
  margin: 0 auto;
}

.item {
  width: 200px;
}

.icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
}

.icon svg {
  width: 100%;
  height: 100%;
}

.item span {
  display: block;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
}

.item .email {
  color: #2B7BF3;
}

.hint {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 12px;
}

.item img {
  width: 120px;
  height: 120px;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .main {
    padding: 30px 20px;
  }
  
  h1 {
    font-size: 28px;
    margin-bottom: 12px;
  }
  
  .desc {
    font-size: 14px;
    margin-bottom: 40px;
    padding: 0 20px;
  }
  
  .contact {
    flex-direction: column;
    gap: 40px;
    align-items: center;
  }
  
  .item {
    width: 100%;
    max-width: 280px;
  }
  
  .icon {
    width: 40px;
    height: 40px;
    margin-bottom: 12px;
  }
  
  .item span {
    font-size: 18px;
    margin-bottom: 8px;
  }
  
  .hint {
    font-size: 13px;
    margin-bottom: 8px;
  }
  
  .item img {
    width: 100px;
    height: 100px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .main {
    padding: 35px 30px;
  }
  
  h1 {
    font-size: 32px;
    margin-bottom: 14px;
  }
  
  .desc {
    font-size: 15px;
    margin-bottom: 50px;
  }
  
  .contact {
    gap: 80px;
  }
  
  .item {
    width: 180px;
  }
  
  .icon {
    width: 44px;
    height: 44px;
    margin-bottom: 14px;
  }
  
  .item span {
    font-size: 19px;
    margin-bottom: 10px;
  }
  
  .hint {
    font-size: 14px;
    margin-bottom: 10px;
  }
  
  .item img {
    width: 110px;
    height: 110px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .main {
    padding: 20px 16px;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .desc {
    font-size: 13px;
    margin-bottom: 30px;
    padding: 0 16px;
  }
  
  .contact {
    gap: 30px;
  }
  
  .item {
    max-width: 240px;
  }
  
  .icon {
    width: 36px;
    height: 36px;
    margin-bottom: 10px;
  }
  
  .item span {
    font-size: 16px;
    margin-bottom: 6px;
  }
  
  .hint {
    font-size: 12px;
    margin-bottom: 6px;
  }
  
  .item img {
    width: 80px;
    height: 80px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .main {
    padding: 25px 20px;
  }
  
  h1 {
    font-size: 26px;
    margin-bottom: 12px;
  }
  
  .desc {
    font-size: 14px;
    margin-bottom: 35px;
  }
  
  .contact {
    flex-direction: row;
    gap: 60px;
  }
  
  .item {
    width: 160px;
  }
  
  .icon {
    width: 38px;
    height: 38px;
    margin-bottom: 12px;
  }
  
  .item span {
    font-size: 17px;
    margin-bottom: 8px;
  }
  
  .hint {
    font-size: 13px;
    margin-bottom: 8px;
  }
  
  .item img {
    width: 90px;
    height: 90px;
  }
}
</style> 